import Dinero from "dinero.js";

// converts a price in countries highest unit (e.g. $10.24) (float)
// to the lowest unit (e.g. 1024 cents) (int)
export function convertPriceHighUnitToLowUnit(
  inFloatAmount,
  currencyDecimals,
  currency
) {
  const factor = Math.pow(10, currencyDecimals);
  return Dinero({
    amount: Math.round(inFloatAmount * factor),
    currency: currency,
    precision: currencyDecimals
  });
}
// converts a price in countries lowest unit (e.g. 1024 cents) (int)
// to the highest unit (e.g. $10.24) (float)
export function convertPriceLowUnitToHighUnit(inIntAmount, currencyDecimals) {
  return Dinero({
    amount: inIntAmount,
    precision: currencyDecimals
  })
    .setLocale("en-US")
    .toUnit();
}
// gets the display price with currency symbol based upon the price
// in a countries lowest unit (e.g. 1024 cents) (int)
// e.g. (1024,2,$) = $10.24
export function getDisplayPrice(inIntAmount, currencyDecimals, currencySymbol) {
  const amount = convertPriceLowUnitToHighUnit(inIntAmount, currencyDecimals);
  return `${currencySymbol}${amount}`;
}
